export default __webpack_public_path__ + "static/media/logo-VipBrasil1.7d2c5686.webp";